/**
 * 项目key值
 */
const state = {
  weatherKey: "8c75ec21aac24aa7b5aee5f29379f24a", //天气预报key值
  weatherLocation: "", //城市代码
  Soid: "bbb7001c6ddcc74d016df626a5190053" // 部门ID
};

export default {
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/key.js